import {  useState } from "react";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import "react-perfect-scrollbar/dist/css/styles.css";
import axios from "axios";

import {
  Box,
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  RadioGroup,
  Radio,
  Input,
} from "@mui/material";

const apiUrl = window.location.hostname === 'localhost' ? 'https://localhost:7142/api' : '/api';

interface NewDptProps {
  onCancel: () => void;
}
function App({ }: NewDptProps) {
  const CreatedByDpt = true; 

    const [service, setService] = useState("");
    const [couleurDuService, setCouleurDuService] = useState("");
    const [poste, setPoste] = useState("");
    const [nom, setNom] = useState("");
    const [prenom, setPrenom] = useState("");
    const [email, setEmail] = useState("");
    const [responsabilite, setResponsabilite] = useState("");
    const [selectedLocalisation, setSelectedLocalisation] = useState("");
    const [selectedfiche, setSelectedFiche] = useState("");
  const [profilePicture, setProfilePicture] = useState(""); 

  const handleChange = (key: string) => (event: any) => {
    let value;

  if (event.target.type === "radio") {
      value = event.target.value;
      
       if (key === "selectedLocalisation") {
        setSelectedLocalisation(value);
      } else if (key === "selectedFiche") {
        setSelectedFiche(value);
      } 
    } else {
      value = event.target.value;

      if (key === "service") {
        setService(value);
      } else if (key === "couleurDuService") {
        setCouleurDuService(value);
      } else if (key === "poste") {
        setPoste(value);
      } else if (key === "nom") {
        setNom(value);
      } else if (key === "prenom") {
        setPrenom(value);
      } else if (key === "email") {
        setEmail(value);
      } else if (key === "responsabilite") {
        setResponsabilite(value);
      } else if (key === "selectedLocalisation") {
        setSelectedLocalisation(value);
      } else if (key === "selectedFiche") {
        setSelectedFiche(value);
      } 
    }
 
  };
   const handleFileChange = (event: any) => {
     const file = event.target.files[0];

     if (file) {
       const reader = new FileReader();
       reader.readAsDataURL(file);

       reader.onloadend = () => {
         const base64String = reader.result as string;
         setProfilePicture(base64String);
       };
     }
   };

  const handleSubmit = async (event: { preventDefault: () => void; }) => {
    event.preventDefault();

    try {
    const responseNvDpt = await axios.post(`${apiUrl}/NvDpt`, {
      service,
      couleurDuService,
      poste,
      nom,
      prenom,
      email,
      responsabilite,
      selectedLocalisation,
      profilePicture,
    });
      const NvDptId = responseNvDpt.data.id;

      await axios.post(`${apiUrl}/Employee`, {
        service,
        poste,
        nom,
        prenom,
        email,
        responsabilite,
        selectedLocalisation,
        profilePicture,
        NvDptId,
        CreatedByDpt 
      });


      setService("");
      setCouleurDuService("");
      setPoste("");
      setNom("");
      setPrenom("");
      setEmail("");
      setResponsabilite("");
      setSelectedLocalisation("");
      setProfilePicture("");
      console.log("Form submitted successfully!");
      window.location.reload()

    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  
  return (
    <Stack
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Paper sx={{ padding: "20px", maxWidth: "1300px" }} className="newdpt">
        <form>
          <Typography
            fontWeight="bold"
            paddingBottom="10px"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "#0C4C92",
              borderBottom: "2px solid rgba(0,0,0,0.1)",
            }}
          >
            Ajouter nouveau département
          </Typography>
          <Grid
            container
            marginTop={4}
            marginBottom={4}
            paddingBottom={4}
            display="flex"
            sx={{
              borderBottom: "2px solid rgba(0,0,0,0.1)",
            }}
          >
            <Grid
              item
              xs={12}
              lg={2}
              display="flex"
              justifyContent="center"
              alignItems="center"
              position="relative"
            >
              <Box
                width="165px"
                padding="15px"
                height="200px"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <img
                  src={profilePicture}
                  alt=""
                  width={140}
                  height={140}
                  style={{
                    borderRadius: "50%",
                    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                  }}
                />
              </Box>
              <label
                htmlFor="profile-picture-input"
                style={{
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  transform: "translate(-50%, 32.5%)",
                  zIndex: 1,
                }}
              >
                <Button
                  variant="contained"
                  component="span"
                  sx={{
                    opacity: 0.8,
                    width: 140,
                    height: 140,
                    borderRadius: "50%",
                    backgroundColor: "rgba(0,0,0,0.6)",
                  }}
                >
                  <svg
                    width="47"
                    height="45"
                    viewBox="0 0 47 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M34.4697 20.9069C37.6297 20.9069 40.6697 22.1639 42.9097 24.4019C45.1397 26.6389 46.3997 29.6739 46.3997 32.8389C46.3997 36.0029 45.1397 39.0379 42.9097 41.2759C40.6697 43.5129 37.6297 44.77 34.4697 44.77C31.2997 44.77 28.2698 43.5129 26.0298 41.2759C23.7898 39.0379 22.5398 36.0029 22.5398 32.8389C22.5398 29.6739 23.7898 26.6389 26.0298 24.4019C28.2698 22.1639 31.2997 20.9069 34.4697 20.9069ZM34.4697 25.2459L34.2698 25.2629C34.0598 25.3029 33.8597 25.4079 33.6997 25.5629C33.5497 25.7189 33.4397 25.9189 33.3997 26.1349L33.3796 26.3309V31.754H27.9597L27.7598 31.7739C27.5398 31.8129 27.3497 31.9179 27.1897 32.0739C27.0297 32.2289 26.9296 32.4289 26.8896 32.6459L26.8699 32.8409L26.8896 33.0359C26.9296 33.2529 27.0297 33.4519 27.1897 33.6079C27.3497 33.7639 27.5398 33.869 27.7598 33.908L27.9597 33.926H33.3796V39.356L33.3997 39.551C33.4397 39.767 33.5497 39.9669 33.6997 40.1229C33.8597 40.2789 34.0598 40.3829 34.2698 40.4229L34.4697 40.4399L34.6597 40.4229C34.8797 40.3829 35.0797 40.2789 35.2397 40.1229C35.3897 39.9669 35.4998 39.767 35.5398 39.551L35.5498 39.356V33.9229H40.9897L41.1797 33.908C41.3997 33.869 41.5998 33.7639 41.7498 33.6079C41.9098 33.4519 42.0098 33.2529 42.0498 33.0359L42.0698 32.8409L42.0498 32.6459C42.0098 32.4289 41.9098 32.2289 41.7498 32.0729C41.5998 31.9169 41.3997 31.8129 41.1797 31.7739L40.9797 31.7559H35.5498V26.3329L35.5398 26.1379C35.4998 25.9199 35.3897 25.72 35.2397 25.564C35.0797 25.408 34.8797 25.3029 34.6597 25.2629L34.4697 25.2459ZM26.7097 0.306946C27.5597 0.306946 28.3996 0.528928 29.1396 0.950928C29.8796 1.37393 30.4897 1.98197 30.9197 2.71497L32.6897 5.72394H37.1797C39.0497 5.72394 40.8397 6.46596 42.1697 7.78796C43.4897 9.10996 44.2297 10.9029 44.2297 12.7719V22.6639C43.2597 21.7349 42.1697 20.9489 40.9797 20.3279V12.7719C40.9797 11.7649 40.5799 10.8 39.8699 10.088C39.1499 9.37595 38.1897 8.97595 37.1797 8.97595H31.7598C31.4698 8.97595 31.1897 8.90193 30.9497 8.76093C30.6997 8.61993 30.4999 8.41791 30.3499 8.17291L28.1099 4.36096C27.9699 4.11696 27.7698 3.91493 27.5198 3.77393C27.2798 3.63293 26.9997 3.55896 26.7097 3.55896H18.4597C18.2297 3.55896 17.9898 3.61091 17.7798 3.71191C17.5598 3.81191 17.3697 3.95795 17.2197 4.13995L17.0798 4.33496L14.7097 8.19891C14.5597 8.43591 14.3599 8.63194 14.1099 8.76794C13.8699 8.90394 13.5998 8.97595 13.3198 8.97595H7.89966C7.39966 8.97495 6.8997 9.07292 6.4397 9.26392C5.9797 9.45492 5.55972 9.73391 5.20972 10.0869C4.85972 10.4389 4.57965 10.8579 4.38965 11.3189C4.19965 11.7789 4.09985 12.2729 4.09985 12.7719V33.3809C4.09985 35.4769 5.79965 37.1769 7.88965 37.1769H21.0498C21.4198 38.3339 21.9398 39.4269 22.5898 40.4319H7.88965C6.01965 40.4319 4.22967 39.689 2.90967 38.366C1.58967 37.044 0.839844 35.2509 0.839844 33.3809V12.7719C0.839844 10.9019 1.58967 9.10893 2.90967 7.78693C4.22967 6.46393 6.01965 5.72192 7.88965 5.72192H12.4097L14.2998 2.63196C14.7398 1.92096 15.3498 1.33394 16.0798 0.926941C16.8098 0.518941 17.6297 0.304932 18.4597 0.304932L26.7097 0.306946ZM22.5398 12.2299C24.5998 12.2299 26.6098 12.8829 28.2798 14.0969C29.9498 15.3109 31.1898 17.0219 31.8298 18.9849C30.7398 19.1909 29.6997 19.5209 28.7197 19.9589C28.2397 18.4859 27.2497 17.2329 25.9297 16.4249C24.5997 15.6179 23.0398 15.309 21.5098 15.554C19.9798 15.799 18.5798 16.582 17.5798 17.762C16.5798 18.942 16.0298 20.4419 16.0298 21.9919C16.0298 25.0939 18.1999 27.6859 21.0999 28.3419C20.7499 29.3729 20.5297 30.4409 20.4297 31.5239C18.0897 30.9989 16.0199 29.6289 14.6199 27.6749C13.2199 25.7219 12.5999 23.3219 12.8599 20.9349C13.1199 18.5479 14.2498 16.3409 16.0398 14.7349C17.8198 13.1299 20.1398 12.2389 22.5398 12.2319V12.2299Z"
                      fill="white"
                    />
                  </svg>
                </Button>
              </label>
              <Input
                type="file"
                onChange={handleFileChange}
                id="profile-picture-input"
                inputProps={{ accept: "image/*" }}
                sx={{ display: "none" }}
              />
            </Grid>
            <Grid item container xs={12} lg={10}>
              <Grid item container display="flex" xs={12}>
                <Grid
                  container
                  item
                  display="flex"
                  justifyContent="start"
                  spacing={2}
                  alignItems="center"
                  marginX={2}
                >
                  <Grid item md={5} xs={12}>
                    <InputLabel htmlFor="nom-du-service">
                      Nom du service
                    </InputLabel>
                    <TextField
                      id="nom-du-service"
                      variant="outlined"
                      fullWidth
                      value={service}
                      onChange={handleChange("service")}
                    />
                  </Grid>
                  <Grid item md={2} xs={12}>
                    <InputLabel
                      sx={{ overflow: "visible" }}
                      htmlFor="couleur-du-service"
                    >
                      Couleur du service
                    </InputLabel>
                    <Select
                      variant="outlined"
                      fullWidth
                      value={couleurDuService}
                      onChange={handleChange("couleurDuService")}
                    >
                      <MenuItem
                        value="#05FFC3"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#05FFC3"
                            fill-opacity="0.63"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#12F1FF"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#12F1FF"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#9ED4E8"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#9ED4E8"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#AACBF0"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#AACBF0"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#BCD0F1"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#BCD0F1"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#BDBBF2"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#BDBBF2"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#CA91CF"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#CA91CF"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#D17BAA"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#D17BAA"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#D17B82"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#D17B82"
                          />
                        </svg>
                      </MenuItem>
                      <MenuItem
                        value="#D05158"
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <svg
                          width="25"
                          height="22"
                          viewBox="0 0 25 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 -1.74846e-07C22.7091 -7.8281e-08 24.5 1.79086 24.5 4L24.5 18C24.5 20.2091 22.7091 22 20.5 22L4.5 22C2.29086 22 0.499999 20.2091 0.499999 18L0.5 4C0.5 1.79086 2.29086 -9.70792e-07 4.5 -8.74228e-07L20.5 -1.74846e-07Z"
                            fill="#D05158"
                          />
                        </svg>
                      </MenuItem>
                    </Select>
                  </Grid>
                  <Grid item md={5} xs={12}>
                    <InputLabel htmlFor="nom-du-poste">Nom du poste</InputLabel>
                    <TextField
                      id="nom-du-poste"
                      variant="outlined"
                      fullWidth
                      value={poste}
                      onChange={handleChange("poste")}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                item
                display="flex"
                justifyContent="start"
                spacing={2}
                alignItems="center"
                marginX={2}
              >
                <Grid item lg={3} sm={6} xs={12}>
                  <InputLabel htmlFor="nom">Nom</InputLabel>
                  <TextField
                    id="nom"
                    variant="outlined"
                    fullWidth
                    value={nom}
                    onChange={handleChange("nom")}
                  />
                </Grid>
                <Grid item lg={3} sm={6} xs={12}>
                  <InputLabel htmlFor="Prénom">Prénom</InputLabel>
                  <TextField
                    id="Prénom"
                    variant="outlined"
                    fullWidth
                    value={prenom}
                    onChange={handleChange("prenom")}
                  />
                </Grid>
                <Grid item lg={3} sm={6} xs={12}>
                  <InputLabel htmlFor="Email">Email</InputLabel>
                  <TextField
                    id="Email"
                    variant="outlined"
                    type="email"
                    fullWidth
                    value={email}
                    onChange={handleChange("email")}
                  />
                </Grid>

                <Grid item lg={3} sm={6} xs={12}>
                  <InputLabel
                    htmlFor="couleur-du-service"
                    sx={{ overflow: "visible" }}
                  >
                    Selectionner le role
                  </InputLabel>
                  <Select
                    variant="outlined"
                    fullWidth
                    sx={{ backgroundColor: "#F4F4F4" }}
                    value={responsabilite}
                    onChange={handleChange("responsabilite")}
                  >
                    <MenuItem value="cadre">Cadre</MenuItem>
                    <MenuItem value="chef de service">Chef de service</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div>
            <Typography
              fontWeight="semibold"
              paddingLeft={6}
              paddingBottom="10px"
              paddingTop="10px"
              sx={{
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: "#F0F4F8",
              }}
            >
              Localisation{" "}
            </Typography>
            <Grid container className="radio" width="auto">
              <RadioGroup
                row
                value={selectedLocalisation}
                onChange={handleChange("selectedLocalisation")}
              >
                <Grid item>
                  {" "}
                  <FormGroup row>
                    <FormControlLabel
                      value="En bas de RH"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="En bas de RH"
                    />
                    <FormControlLabel
                      value="A droit de Chef d’Hebergement"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="A droit de Chef d’Hebergement"
                    />
                    <FormControlLabel
                      value="A droit de Spa Manager"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="A droit de Spa Manager"
                    />
                    <FormControlLabel
                      value="A droit de Chef de réception"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="A droit de Chef de réception"
                    />
                  </FormGroup>{" "}
                </Grid>
                <Grid item>
                  {" "}
                  <FormGroup row>
                    <FormControlLabel
                      value="A droit de Housekeeping Manager"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="A droit de Housekeeping Manager"
                    />
                    <FormControlLabel
                      value="Par defaut"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Par defaut"
                    />
                  </FormGroup>{" "}
                </Grid>
              </RadioGroup>
            </Grid>
          </div>
          <div
            style={{
              borderBottom: "2px solid rgba(0,0,0,0.1)",
              paddingBottom: "20px",
            }}
          >
            <Typography
              fontWeight="semibold"
              paddingLeft={6}
              paddingBottom="10px"
              paddingTop="10px"
              sx={{
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: "#F0F4F8",
              }}
            >
              Créer fiche employé comme{" "}
            </Typography>
            <Grid container className="radio" width="auto">
              <RadioGroup
                row
                value={selectedfiche}
                onChange={handleChange("selectedFiche")}
              >
                <Grid item>
                  <FormGroup row>
                    <FormControlLabel
                      value="Employé voiturier"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Employé voiturier"
                    />
                    <FormControlLabel
                      value="Employé RH"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Employé RH"
                    />
                    <FormControlLabel
                      value="Employé Réception"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Employé Réception"
                    />
                    <FormControlLabel
                      value="Employé concierge"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Employé concierge"
                    />
                  </FormGroup>
                </Grid>
                <Grid item>
                  <FormGroup row>
                    <FormControlLabel
                      value="Employé Spa"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Employé Spa"
                    />
                    <FormControlLabel
                      value="Employé salle"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Employé salle"
                    />
                    <FormControlLabel
                      value="Employé Housekeeping"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Employé Housekeeping"
                    />
                    <FormControlLabel
                      value="Employé cuisine"
                      control={
                        <Radio
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                        />
                      }
                      label="Employé cuisine"
                    />
                  </FormGroup>
                </Grid>
              </RadioGroup>
            </Grid>
          </div>
          <Grid container justifyContent="space-between">
            <Grid item paddingY={2}>
              <FormControlLabel
                control={<Checkbox />}
                label="Créer planning pour le nouveau département"
              />
            </Grid>
            <Grid item paddingY={2}>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0B4B92", borderRadius: "10px" }}
                type="submit"
                onClick={handleSubmit}
              >
                <Typography
                  fontWeight="bold"
                  fontSize="12px"
                  padding={1}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Creer nouveau département
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Stack>
  );
}

export default App;
